import React from "react";

const Awwwards = () => {
  return (
    <svg
      width="29"
      height="17"
      viewBox="0 0 29 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.3503 0L17.3165 15.7056H13.8935L11.1752 5.53725L8.45688 15.756H5.03386L0 0.0503383H3.92641L6.74537 10.8228L9.41332 0.0503383H12.9874L15.6553 10.8228L18.4743 0.0503383L22.3503 0Z" />
      <path d="M28.2352 13.6176C28.2352 12.1074 27.1278 11 25.6176 11C24.1578 11 23 12.1074 23 13.6176C23 15.1278 24.1074 16.2352 25.6176 16.2352C27.1278 16.2352 28.2352 15.1278 28.2352 13.6176Z" />
    </svg>
  );
};

export default Awwwards;
